import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Chip,
  Avatar,
  Typography
} from '@mui/material';
import { Store as StoreIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useStore } from '../context/StoreContext';

const StoreSelector = ({ variant = 'outlined', size = 'medium' }) => {
  const { currentStore, availableStores, switchStore, loading } = useStore();
  const { t } = useTranslation();

  if (loading) {
    return <Typography variant="body2">{t('storeSelector.loadingStores')}</Typography>;
    }
    

    console.log('availableStores:', availableStores);
    console.log('currentStore:', currentStore);

    if (availableStores.length === 0) {
        return (
            <Chip
                label={t('storeSelector.noStoresAvailable')}
                color="warning"
                size="small"
            />
        );
    }

  return (
    <FormControl variant={variant} size={size} sx={{ minWidth: 200 }}>
      <InputLabel>{t('storeSelector.currentStore')}</InputLabel>
      <Select
        value={currentStore?.storeId || currentStore?.id || ''}
        onChange={(e) => {
          const store = availableStores.find(
            s => (s.storeId || s.id) === e.target.value
          );
          if (store) switchStore(store);
        }}
        label={t('storeSelector.currentStore')}
        startAdornment={
          <StoreIcon sx={{ mr: 1, color: 'action.active' }} fontSize="small" />
        }
      >
        {availableStores.map((store) => (
          <MenuItem key={store.storeId || store.id} value={store.storeId || store.id}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Avatar sx={{ width: 24, height: 24, bgcolor: 'primary.main', fontSize: '0.75rem' }}>
                {(store.storeName || store.name)?.charAt(0).toUpperCase()}
              </Avatar>
              <Box>
                <Typography variant="body2">
                  {store.storeName || store.name}
                </Typography>
                {store.role && (
                  <Chip
                    label={store.role}
                    size="small"
                    color="secondary"
                    sx={{ height: 16, fontSize: '0.65rem' }}
                  />
                )}
              </Box>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default StoreSelector;
